// frontend/src/askos/DashboardHome.js
//
// Matches the dashboard layout in /askos-dashboard.html: hero + chat card,
// then panel grids. Cards backed by real Phase 1 data (chat, subject
// progress, recent conversations, current affairs) render live values;
// Phase 2/3 cards (study plan, recommended, PYQ, performance, streak) show
// an honest "coming soon" state in the same visual shape — no fake data.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AskosChat from './AskosChat';
import SubjectProgressCard from './SubjectProgressCard';
import RecentConversationsCard from './RecentConversationsCard';
import CurrentAffairsCard from './CurrentAffairsCard';
import TodayStudyPlanCard from './TodayStudyPlanCard';
import RecommendedForYouCard from './RecommendedForYouCard';
import LiveSessionCard from './liveSessions/LiveSessionCard';
import PyqPracticeCard from './PyqPracticeCard';
import PerformanceSnapshotCard from './PerformanceSnapshotCard';
import StudyStreakCard from './StudyStreakCard';

const DashboardHome = ({ slug }) => {
    const navigate = useNavigate();

    return (
        <>
            <section className="hero-card">
                <div className="hero-copy">
                    <p className="eyebrow">Welcome back to</p>
                    <h2>Ask<span>OS</span></h2>
                    <p className="hero-text">Your 24×7 AI mentor for UPSC success.<br />Ask. Learn. Grow. Succeed.</p>
                    <div className="hero-actions">
                        <button type="button" className="primary-btn" onClick={() => navigate('/samkalp-ias/ask-askos')}>💬 Ask a Doubt</button>
                        <button type="button" className="secondary-btn" onClick={() => navigate('/samkalp-ias/study-plan')}>▷ Continue Study Plan</button>
                    </div>
                </div>
                <AskosChat slug={slug} compact />
            </section>

            <section className="grid two-col">
                <TodayStudyPlanCard slug={slug} />
                <RecentConversationsCard slug={slug} />
            </section>

            <section className="grid two-col compact">
                <LiveSessionCard slug={slug} />
                <CurrentAffairsCard slug={slug} />
            </section>

            <section className="grid two-col compact">
                <RecommendedForYouCard slug={slug} />
            </section>

            <section className="grid progress-layout">
                <SubjectProgressCard slug={slug} />
                <PyqPracticeCard slug={slug} />
            </section>

            <section className="grid two-col bottom-grid">
                <PerformanceSnapshotCard slug={slug} />
                <StudyStreakCard slug={slug} />
            </section>

            <footer>❝ Small daily progress leads to big results. Stay focused, stay consistent, you've got this! ✨</footer>
        </>
    );
};

export default DashboardHome;
